import React from 'react';
import '../../styles/RedirectLink.css';
import Text from './Text';

interface RedirectLinkProps {
  text: string;
  icon: string;
}

export const RedirectLink: React.FC<RedirectLinkProps> = ({ text, icon }) => {
  return (
    <div className="redirect-to">
      <img src={icon} alt="icon" className="icon" />
      <Text>{text}</Text>
    </div>
  );
};
